<h4 class="m-top-15" *ngIf="showHeader === true">Weekly Overview</h4>

<div class="table-container">
  <table class="session-log-user-stickiness" width="100%">
    <thead>
      <tr>
        <th>Date</th>
        <th>Total Users</th>
        <th>Unique Users last 7 Days</th>
        <th>WAU/Total %</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let day of dataDisplay">
        <th>{{day.date | date:'dd/MM/yyyy'}}</th>
        <td class="cell-divider">{{day.totalUsers}}</td>
        <td>{{day.weeklyActiveUsers}}</td>
        <td class="cell-divider">{{calculateWeeklyActiveVsTotal(day)}}</td>
      </tr>
    </tbody>
  </table>
</div>